import { getCampaigns } from '../../api';
import { useProcessedList } from '../../hooks';
import type { GetCampaignsFilters, CampaignType } from '../../api';

export const useCampaigns = () => {
  return useProcessedList<CampaignType, GetCampaignsFilters>(
    async params => {
      const result = await getCampaigns(
        params?.filters || {},
        params.pagination
      );

      return { content: result.items, total: result.total };
    },
    {
      initialPageSize: 50,
      initialFilters: { status: '' },
      initialSort: { name: 'name', direction: 'asc' },
      searchKeys: ['name', 'description'],
      searchFilterKey: 'search',
      withLocalSort: true,
      withQueryParams: true,
      storageKey: 'use-campaigns-list',
    }
  );
};

export type ItemType = CampaignType;
